export default __webpack_public_path__ + "static/Abhijeet-e2f676ebbd1e4dc1ae1526fcec9a0449.png";